import Vue from 'vue'
import App from './App.vue'
import { BootstrapVue } from 'bootstrap-vue'

import './assets/formulate.css'
import VueFormulate from '@braid/vue-formulate'

import FormulateVSelectPlugin from '@cone2875/vue-formulate-select'
import VueTypeaheadBootstrap from 'vue-typeahead-bootstrap'
import vSelect from 'vue-select'
import VueRouter from 'vue-router'
import axios from 'axios'
import VueAxios from 'vue-axios'

// Make BootstrapVue available throughout your project
Vue.use(BootstrapVue)

Vue.use(VueAxios, axios)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'vue-select/dist/vue-select.css'

Vue.use(VueFormulate, {
  // Define our custom slot component(s)
  slotComponents: {},
  // Define any props we want to pass to our slot component
  slotProps: {},
  plugins: [FormulateVSelectPlugin]
})

// Global registration
Vue.component('vue-typeahead-bootstrap', VueTypeaheadBootstrap)

Vue.component('v-select', vSelect)

Vue.use(VueRouter)

import Home from './pages/Home.vue'
import RequestForm from './pages/RequestForm.vue'
import DailyNoShowForm from './pages/DailyNoShowForm.vue'
import CalendarForm from './pages/CalendarForm.vue'
import EventList from './pages/CalendarForm/EventList.vue'
import StudentList from './pages/StudentList.vue'
import CancelForm from './pages/CancelForm.vue'
import OneTimeNoRide from './pages/OneTimeNoRide.vue'
import VueCustomElement from 'vue-custom-element'

const router = new VueRouter({
  routes: [
    { path: '/', component: Home },
    {
      path: '/RequestForm',
      name: 'RequestForm',
      component: RequestForm,
      props: true
    },
    { path: '/DailyNoShowForm', component: DailyNoShowForm },
    {
      path: '/OneTimeNoRide',
      name: 'OneTimeNoRide',
      component: OneTimeNoRide,
      props: true
    },
    {
      path: '/CalendarForm/',
      name: 'CalendarForm',
      component: CalendarForm,
      props: true
    },
    {
      path: '/CalendarForm/EventList',
      name: 'EventList',
      component: EventList
    },

    {
      path: '/StudentList',
      name: 'StudentList',
      component: StudentList,
      props: true
    },

    {
      path: '/CancelForm',
      name: 'CancelForm',
      component: CancelForm,
      props: true
    }
  ]
})

Vue.config.productionTip = false

Vue.use(VueCustomElement)

App.router = router
const elementOptions = {
  props: {
    siteHomeUrl: window?.CESO_KANAN_DATA?.siteHomeUrl,
    apiUrl: window?.CESO_KANAN_DATA?.apiUrl,
    nonce: window?.CESO_KANAN_DATA?.nonce
  }
}
Vue.customElement('kanan-main-app', App, elementOptions)
Vue.customElement('kanan-otnr-form', OneTimeNoRide, elementOptions)
